import React from "react";
import { SectionCard, KV, money } from "./common";
import { PropertyMemory } from "./MiscTabs";

export function OverviewTab({ property, currency }) {
  const p = property;
  const m = p.mortgage || {};
  const cards = [
    ["Purchase date", p.purchase_date || "—"],
    ["Purchase price", money(p.purchase_price, currency)],
    ["Estimated market value", money(p.estimated_market_value, currency)],
    ["Estimated equity", money(p.estimated_equity, currency)],
    ["Monthly cash flow", money(p.monthly_cash_flow, currency)],
    ["Occupancy", p.occupancy_status],
    ["Mortgage balance", money(m.remaining_balance, currency)],
    ["Next action", p.next_action ? `${p.next_action.label}${p.next_action.date ? " · " + p.next_action.date : ""}` : "Nothing scheduled"],
  ];
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="overview-cards">
        {cards.map(([label, val]) => (
          <div key={label} className="glass-card rounded-2xl p-5">
            <div className="text-[10px] uppercase tracking-[0.12em] text-[#8A7F70]">{label}</div>
            <div className="font-display text-xl text-[#2C2A28] mt-2 break-words">{val}</div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SectionCard title="Property details">
          <KV label="Nickname" value={p.nickname} />
          <KV label="Address" value={p.address} />
          <KV label="Purchase date" value={p.purchase_date} />
          <KV label="Purchase price" value={money(p.purchase_price, currency)} />
          <KV label="Occupancy" value={p.occupancy_status} />
        </SectionCard>
        <PropertyMemory />
      </div>
    </div>
  );
}
